export enum RoleEnum {
  ADMIN = '00001',
  STAFF = '00002',
  TECHNICIAN = '00003',
}

export enum RoleEnumString {
  ADMIN = 'Admin',
  STAFF = 'Staff',
  TECHNICIAN = 'Technician',
}

export enum HeaderEnum {
  TIME_ZONE = 'time-zone',
}

export enum MessageTypeEnum {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  AUDIO = 'AUDIO',
  FILE = 'FILE',
  EMOTION = 'EMOTION',
  LOCATION = 'LOCATION',
  IMAGE = 'IMAGE',
  MEDIA = 'MEDIA',
}

export enum MessageFileTypeEnum {
  IMAGE = 'IMAGE',
  FILE = 'FILE',
  MEDIA = 'MEDIA',
}

export enum MenuNameEnum {
  DASHBOARD = 'menu_dashboard',
  EMPLOYEES = 'menu_employees',
  CUSTOMERS = 'menu_customers',
  CUSTOMER_DETAIL = 'menu_customer_detail',
  CONTACT_DETAIL = 'menu_contact_detail',
  SCHEDULE = 'menu_schedule',
  CRM = 'menu_crm',
  INVENTORY = 'menu_inventory',
  MARKETING = 'menu_marketing',
  CAMPAIGNS = 'menu_campaigns',
  SERVICES = 'menu_services',
  SERVICE_DETAIL = 'menu_service_detail',
  MATERIALS = 'menu_materials',
  ESTIMATE_TEMPLATE = 'menu_estimate_template',
  PRICE_BOOKS = 'menu_price_books',
  CONTACTS = 'menu_contacts',
  PIPELINE = 'menu_pipeline',
  JOBS = 'menu_jobs',
  JOBS_DETAIL = 'menu_jobs_detail',
  TASKS = 'menu_tasks',
  ESTIMATE = 'menu_estimate',
  TIME_CLOCK = 'menu_time_clock',
  PAYROLL = 'menu_payroll',
  REPORTS = 'menu_reports',
  SETTINGS = 'menu_settings',
  INTEGRATION = 'menu_integration',
  INVOICE = 'menu_invoice',
  TAGS = 'menu_tags',
  CATEGORY = 'menu_category',
  LEAD_SOURCE = 'menu_lead_source',
  REVIEW = 'menu_review',
}

export enum InputTypeEnum {
  TEXT = 'text',
  PASSWORD = 'password',
  NUMBER = 'number',
  DATE = 'date',
  TIME = 'time',
  FILE = 'file',
}

export enum SearchByFilterEnum {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  ADDRESS = 'ADDRESS',
  CUSTOMER = 'CUSTOMER',
  JOB_TYPE = 'TYPE',
  JOB_TAG = 'TAG',
  LEAD_SOURCE = 'SOURCE',
  ROLE = 'ROLE',
  POSITION = 'POSITION',
  STATUS = 'STATUS',
  PART_NUMBER = 'PART_NUMBER',
  TASK_CODE = 'TASK_CODE',
  PRODUCT = 'PRODUCT',
  RECEIPT = 'RECEIPT',
  CONTENT = 'CONTENT',
  EMPLOYEE = 'EMPLOYEE',
  JOB_ID = 'jobId',
  CUSTOMER_NAME = 'customerName',
  ASSIGNEES = 'assignees',
}

export enum SearchByFilterContentEnum {
  ID = 'Id',
  NAME = 'Name',
  EMAIL = 'Email',
  PHONE = 'Phone',
  ADDRESS = 'Address',
  CUSTOMER = 'Customer',
  JOB_TYPE = 'Job Type',
  CUSTOMER_TAG = 'Customer Tag',
  LEAD_SOURCE = 'Lead Source',
  PO_NUMBER = 'PO Number',
  CONTENT = 'Content',
  JOB_NAME = 'Job Name',
}

export enum CustomerDetailTabsEnum {
  INFORMATION = 'information',
  DOCUMENTS = 'documents',
  ESTIMATE = 'estimate',
  JOBS = 'jobs',
  ACTIVITIES = 'activities',
  SCHEDULE = 'schedule',
  INVOICES = 'invoices',
}

export enum ServiceDetailTabsEnum {
  INFORMATION = 'information',
}

export enum PriceBookDetailTabsEnum {
  INFORMATION = 'information',
}

// export enum ScheduleDetailTabsEnum {
//   SUMMARY = 'summary',
//   NOTES = 'notes',
// }

export enum ContactDetailTabsEnum {
  INFORMATION = 'information',
  ACTIVITIES = 'activities',
  DOCUMENT = 'document',
}

export enum JobDetailTabsEnum {
  SUMMARY = 'summary',
  PO = 'po',
  SCHEDULE = 'schedule',
  DOCUMENTS = 'documents',
  LINE_ITEMS = 'line_items',
  ESTIMATE = 'estimate',
  INVOICE = 'invoice',
  NOTE = 'note',
  TASK = 'task',
  ACTIVITIES = 'activities',
}

export enum TaskDetailTabsEnum {
  INFORMATION = 'information',
}

export enum EstimateDetailTabsEnum {
  SUMMARY = 'summary',
  DOCUMENTS = 'documents',
  LINE_ITEMS = 'line_items',
  ACTIVITIES = 'activities',
  SCHEDULE = 'schedule',
  NOTE = 'note',
}

export enum FileDocumentTypeEnum {
  IMAGE = 'image',
  ANY = 'any',
}

export enum ToastPositionTypeEnum {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum ToastTypeEnum {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export enum DateFormatEnum {
  DD_MMM_YYYY = 'DD MMM YYYY',
  MM_DD_YYYY = 'MM/DD/YYYY',
  YYYY_MM_DD = 'YYYY-MM-DD',
  MMMM_YYYY = 'MMMM YYYY',
  MM_DD_YYYY_HH_AM_PM = 'DD MMM YYYY h:mm A',
  DDDD = 'dddd',
  DD_MMM_YYYY_H_MM_A = 'DD MMM YYYY h:mm A',

  HH_MM = 'HH:mm',
  HH_MM_A = 'hh:mm A',
}

export enum TimeFormatEnum {
  HH_MM_SS = 'HH:mm:ss',
  HH_MM = 'HH:mm',
  HH_MM_A_LOWER = 'HH:mm a',
  HH_MM_A_UPPER = 'HH:mm A',
  HH_MM_SS_A_LOWER = 'hh:mm:ss a',
  HH_MM_SS_A_UPPER = 'hh:mm:ss A',
  HOUR_MINUTE_AM_PM = 'h:mm A',
}

export enum KeyboardEnum {
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  DELETE = 'Delete',
  SPACE = ' ',
  BACKSPACE = 'Backspace',
  TAB = 'Tab',
  ENTER = 'Enter',
}

export enum ClipboardDataEnum {
  TEXT = 'text',
}

export enum BusinessTypeEnum {
  EVENT = 'EVENT',
  CUSTOMER = 'CUSTOMER',
  CONTACT = 'CONTACT',
  JOB = 'JOB',
  ESTIMATE = 'ESTIMATE',
  TIME_CLOCK = 'TIME_CLOCK',
  TASK = 'TASK',
}

export enum StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  REJECTED = 'REJECTED',
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  OPEN = 'OPEN',
  PAID = 'PAID',
  SCHEDULED = 'SCHEDULED',
  UNSCHEDULED = 'UNSCHEDULED',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  ACCEPTED = 'ACCEPTED',
  WON = 'WON',
  LOST = 'LOST',
  CONVERT_TO_JOB = 'CONVERT_TO_JOB',
  DELAY = 'DELAY',
  TODO = 'TODO',
  UN_PAID = 'UN_PAID',
  NO_GO = 'NO_GO',
  RECALL = 'RECALL',
  J_O_H = 'J_O_H',
  J_I_P = 'J_I_P',
}

export enum ChipColorEnum {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum PlaceAddressEnum {
  LOCALITY = 'locality',
  STATE = 'administrative_area_level_1',
  ZIP_CODE = 'postal_code',
  COUNTRY = 'country',
}

export enum ActivityTypeEnum {
  CREATE_CUSTOMER = 'CREATE_CUSTOMER',
  UPDATE_CUSTOMER = 'UPDATE_CUSTOMER',
  CHANGE_STATUS_CUSTOMER = 'CHANGE_STATUS_CUSTOMER',
  CREATE_FOLDER = 'CREATE_FOLDER',
  DELETE_FOLDER = 'DELETE_FOLDER',
  UPLOAD_FILE = 'UPLOAD_FILE',
  DELETE_FILE = 'DELETE_FILE',
  ASSIGNED_JOB = 'ASSIGNED_JOB',
  ASSIGNED_SCHEDULE = 'ASSIGNED_SCHEDULE',
  CHANGE_STATUS_CONTACT = 'CHANGE_STATUS_CONTACT',
  CREATE_JOB = 'CREATE_JOB',
  CREATE_NOTE = 'CREATE_NOTE',
  UPDATE_NOTE = 'UPDATE_NOTE',
  DELETE_NOTE = 'DELETE_NOTE',
  CREATE_ESTIMATE = 'CREATE_ESTIMATE',
  CHANGE_STATUS_ESTIMATE = 'CHANGE_STATUS_ESTIMATE',
  CONVERT_ESTIMATE_TO_JOB = 'CONVERT_ESTIMATE_TO_JOB',
  UPDATE_LINE_ITEM_ESTIMATE = 'UPDATE_LINE_ITEM_ESTIMATE',
  UPDATE_ESTIMATE_FIELDS = 'UPDATE_ESTIMATE_FIELDS',
  UPDATE_LEAD_SOURCE_ESTIMATE = 'UPDATE_LEAD_SOURCE_ESTIMATE',
  UPDATE_ESTIMATE_TAGS = 'UPDATE_ESTIMATE_TAGS',
  UPDATE_SCHEDULE_ESTIMATE = 'UPDATE_SCHEDULE_ESTIMATE',
  UPDATE_PRIVATE_NOTES_ESTIMATE = 'UPDATE_PRIVATE_NOTES_ESTIMATE',
  UPDATE_CUSTOMER_ESTIMATE = 'UPDATE_CUSTOMER_ESTIMATE',
  UPDATE_LINE_ITEM_JOB = 'UPDATE_LINE_ITEM_JOB',
  UPDATE_JOB_FIELDS = 'UPDATE_JOB_FIELDS',
  UPDATE_LEAD_SOURCE_JOB = 'UPDATE_LEAD_SOURCE_JOB',
  UPDATE_JOB_TAGS = 'UPDATE_JOB_TAGS',
  UPDATE_SCHEDULE_JOB = 'UPDATE_SCHEDULE_JOB',
  UPDATE_PRIVATE_NOTES_JOB = 'UPDATE_PRIVATE_NOTES_JOB',
  UPDATE_CUSTOMER_JOB = 'UPDATE_CUSTOMER_JOB',
  UPDATE_TASKS = 'UPDATE_TASKS',
}

export enum ActivityTypeIconEnum {
  CREATED = 'CREATE',
  UPDATED = 'UPDATE',
  UPLOADED = 'UPLOAD',
  CHANGE_STATUS = 'CHANGE',
  DELETED = 'DELETE',
  ASSIGNED = 'ASSIGN',
  CONVERT = 'CONVERT',
}

export enum SignInTypeEnum {
  STANDARD = 'STANDARD',
}

export enum ScheduleTypeEnum {
  BOOKING_A_JOB = 'JOB',
  BOOKING_A_CALL = 'CONTACT',
  BOOKING_A_RETURN_CUSTOMER = 'CUSTOMER',
  EVENT = 'EVENT',
  TASK = 'TASK',
  ESTIMATE = 'ESTIMATE',
}

export enum ScheduleViewModeEnum {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
}

export enum VerifyTypeEnum {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
}

export enum ModeTextEditorEnum {
  VIEW = 'view',
  CREATE = 'create',
  EDIT = 'edit',
}

export enum ThemeTextEditorEnum {
  SNOW = 'snow',
  BUBBLE = 'bubble',
}

export enum ActivityNameEnum {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  COUNTRY_CODE = 'countryCode',
  BILLING_CITY = 'billingCity',
  CITY = 'city',
  ZIP_CODE = 'zipCode',
  STATE = 'state',
  BILLING_ZIP_CODE = 'billingZipCode',
  ADDRESS = 'address',
  BILLING_STATE = 'billingState',
  COUNTRY = 'country',
  PHONE_NUMBER = 'phoneNumber',
  BILLING_ADDRESS = 'billingAddress',
  BILLING_ADDRESS_2 = 'billingAddress2',
  BILLING_COUNTRY = 'billingCountry',
  EMAIL = 'email',
  ADDRESS_2 = 'address2',
  CUSTOMER_CONTACTS = 'customerContacts',
  AVATAR_IMAGE = 'avatarImage',
  FILE_NAME = 'fileName',
  FOLDER_NAME = 'folderName',
  NAME = 'name',
  TYPE = 'type',
  TAGS = 'tags',
  ASSIGNEE = 'assignee',

  CONTENT = 'content',
  REFERRAL_TYPE = 'referralType',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  TOTAL = 'total',
  SOURCE = 'source',
  CALLBACK = 'callback',
  UNIT = 'unit',

  FILE_URL = 'fileUrl',

  IS_CURRENT_APPLY = 'isCurrentApply',
}

export enum EmployeeStatusEnum {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum SelectLayoutEnum {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum JobSourceTypeEnum {
  REFERRAL = 'REFERRAL',
}

export enum EstimateSourceTypeEnum {
  REFERRAL = 'REFERRAL',
}

export enum JobReferralTypeEnum {
  CUSTOMER = 'CUSTOMER',
}

export enum EstimateReferralTypeEnum {
  CUSTOMER = 'CUSTOMER',
}

export enum GetListCustomerTypeEnum {
  CUSTOMER = 'CUSTOMER',
  REFERRAL_BY = 'REFERRAL_BY',
}

export enum SortEnum {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum AcceptFileEnum {
  EXCEL = '.xlsx, .xls',
  XLSX = '.xlsx',
  XLS = '.xls',
  CSV = '.csv',
}

export enum ParamsBusinessTypeEnum {
  JOB = 'JOB',
  TIME_CLOCK = 'TIME_CLOCK',
  SCHEDULE = 'SCHEDULE',
  ESTIMATE = 'ESTIMATE',
}

export enum LocaleEnum {
  USD = 'en-US',
}

export enum MaterialDetailTabsEnum {
  INFORMATION = 'information',
}

export enum TimeClockDetailTabsEnum {
  INFORMATION = 'information',
  NOTES = 'notes',
}

export enum MessageStatusEnum {
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  SEEN = 'SEEN',
}

export enum UnitEnum {
  SQ_FT = 'SQ_FT',
  EACH = 'EACH',
}

export enum UnitValueEnum {
  SQ_FT = 'Sq. Ft.',
  EACH = 'Each',
}

export enum BusinessPriceBookTypeEnum {
  ID = 'ID',
  NAME = 'NAME',
}

export enum LocaleCurrencyEnum {
  STYLE = 'currency',
  LOCALE_EN = 'en',
  CURRENCY_USD = 'USD',
  LOCALE_VI = 'vi',
  CURRENCY_VND = 'VND',
}

export enum UnitJobTypeEnum {
  Plumbing = 'PLUMBING',
  HVAC = 'HVAC',
}

export enum TypeDiscountEnum {
  PERCENTAGE = 'PERCENTAGE',
  DOLLAR = 'DOLLAR',
}

export enum LabelTypeDiscountEnum {
  PERCENTAGE = 'Percentage (%)',
  DOLLAR = 'Dollar ($)',
}

export enum TotalStatisticEnum {
  TOTAL_JOBS = 'totalJobs',
  TOTAL_ESTIMATES = 'totalEstimates',
}

export enum TypeCampaignEnum {
  BEFORE_JOB_STARTS = 'BEFORE_JOB_STARTS',
  AFTER_JOB_COMPLETES = 'AFTER_JOB_COMPLETES',
}

export enum StatusJobEnum {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  NO_GO = 'NO_GO',
  RECALL = 'RECALL',
  J_O_H = 'J_O_H',
  J_I_P = 'J_I_P',
  ALL = 'ALL',
}

export enum PageTypeEnum {
  JOB = 'JOB',
  CUSTOMER = 'CUSTOMER',
  SCHEDULE = 'SCHEDULE',
}

export enum BusinessTypeScheduleEnum {
  JOB = 'JOB',
  EVENT = 'EVENT',
  ESTIMATE = 'ESTIMATE',
}

export enum LoadingSizeEnum {
  SMALL = 16,
  MEDIUM = 24,
  LARGE = 32,
}

export enum BusinessModelEnum {
  CUSTOMER = 'CUSTOMER',
  FOLDER = 'FOLDER',
  FILE = 'FILE',
  JOB = 'JOB',
  INVENTORY = 'INVENTORY',
  SCHEDULED = 'SCHEDULED',
  CONTACT = 'CONTACT',
  NOTE = 'NOTE',
  ESTIMATE = 'ESTIMATE',
  INVOICE = 'INVOICE',
  CHANGE_STATUS_ESTIMATE = 'CHANGE_STATUS_ESTIMATE',
  CHANGE_STATUS_JOB = 'CHANGE_STATUS_JOB',
}

export enum NotificationStatusEnum {
  UNREAD = 'UNREAD',
  READ = 'READ',
}

export enum CreateJobTabsEnum {
  CUSTOMER = 'customer',
  SCHEDULE = 'schedule',
  LINE_ITEMS = 'line_items',
  PRIVATE_NOTES = 'private_notes',
  TASK = 'task',
  JOB_FIELDS = 'job_fields',
  JOB_TAGS = 'job_tags',
  LEAD_SOURCE = 'lead_source',
  ATTACHMENT = 'attachment',
}

export enum TypeMasterDataEnum {
  TAG = 'TAG',
  CATEGORY_SERVICE = 'CATEGORY_SERVICE',
  CATEGORY_MATERIAL = 'CATEGORY_MATERIAL',
  LEAD_SOURCE = 'LEAD_SOURCE',
}

export enum TaskStatusEnum {
  TO_DO = 'TODO',
  IN_PROGRESS = 'INPROGRESS',
  DELAY = 'DELAY',
  COMPLETED = 'COMPLETED',
}

export enum CreateEstimateTabsEnum {
  CUSTOMER = 'customer',
  SCHEDULE = 'schedule',
  LINE_ITEMS = 'line_items',
  PRIVATE_NOTES = 'private_notes',
  TASK = 'task',
  FIELDS = 'fields',
  TAGS = 'tags',
  LEAD_SOURCE = 'lead_source',
  PHOTO = 'photo',
  ATTACHMENT = 'attachment',
}

export enum TypeTabCreateJobEnum {
  CUSTOMER = 'CUSTOMER',
  SCHEDULE = 'SCHEDULE',
  LINE_ITEMS = 'LINE_ITEMS',
  PRIVATE_NOTES = 'PRIVATE_NOTES',
  TASK = 'TASK',
  JOB_FIELDS = 'FIELDS',
  JOB_TAGS = 'TAGS',
  LEAD_SOURCE = 'LEAD_SOURCE',
  ATTACHMENT = 'ATTACHMENT',
}

export enum TypeParamJobDetail {
  SUMMARY = 'SUMMARY',
  LINE_ITEM = 'LINE_ITEM',
  TASK = 'TASK',
  ESTIMATE = 'ESTIMATE',
  INVOICE = 'INVOICE',
  DOCUMENT = 'DOCUMENT',
  SCHEDULE = 'SCHEDULE',
  NOTES = 'NOTES',
  ACTIVITIES = 'ACTIVITIES',
}

export enum InvoiceStatusEnum {
  ALL = 'ALL',
  OPEN = 'OPEN',
  PAID = 'PAID',
}

export enum TypeTabCreateEstimateEnum {
  FIELDS = 'FIELDS',
  TAGS = 'TAGS',
  CUSTOMER = 'CUSTOMER',
  SCHEDULE = 'SCHEDULE',
  LINE_ITEMS = 'LINE_ITEMS',
  PRIVATE_NOTES = 'PRIVATE_NOTES',
  LEAD_SOURCE = 'LEAD_SOURCE',
  ATTACHMENT = 'ATTACHMENT',
}

export enum UnitEstimateTypeEnum {
  Plumbing = 'PLUMBING',
  HVAC = 'HVAC',
}

export enum TypeParamEstimateDetail {
  SUMMARY = 'SUMMARY',
  LINE_ITEM = 'LINE_ITEM',
}

export enum TypeLinkQuickBooksEnum {
  NO = 'NO',
  ADD_NEW = 'ADD_NEW',
  ADD_EXISTING = 'ADD_EXISTING',
}

export enum InvoiceSendModeEnum {
  SEND = 'SEND',
  SEND_AND_UPDATE = 'SEND_AND_UPDATE',
}

export enum ReviewSourceEnum {
  INTERNAL = 'INTERNAL',
  GOOGLE = 'GOOGLE',
}

export enum GoogleConnectEnum {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

export enum QuickBookConnectEnum {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

export enum LocationEnum {
  SCHEDULE = '#schedule',
  TASK = '#task',
}

export enum FileTypeEnum {
  DOC = 'doc',
  DOCX = 'docx',
  PDF = 'pdf',
  XLSX = 'xlsx',
  XLS = 'xls',
}

export enum ReportItemEnum {
  TECHNICIAN_PERFORMANCE = 'TECHNICIAN_PERFORMANCE',
  SALE_BY_CITY = 'SALE_BY_CITY',
  SERVICE_VOLUME = 'SERVICE_VOLUME',
  PER_CALL_AVERAGE = 'PER_CALL_AVERAGE',
  PO_PER_PAY_PERIOD = 'PO_PER_PAY_PERIOD',
}

export enum ReportFilterShowByEnum {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  DAY = 'DAY',
}

export enum JobFilterPaymentEnum {
  ALL = 'ALL',
  MISSING_PAYMENT = 'MISSING_PAYMENT',
}
